import { render, staticRenderFns } from "./SimulationQuizRenderer.vue?vue&type=template&id=928842f6&scoped=true&"
import script from "./SimulationQuizRenderer.vue?vue&type=script&lang=js&"
export * from "./SimulationQuizRenderer.vue?vue&type=script&lang=js&"
import style0 from "./SimulationQuizRenderer.vue?vue&type=style&index=0&id=928842f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928842f6",
  null
  
)

export default component.exports